import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { roomsApi } from '../rooms';

export const roomsKeys = ['admin', 'timetable', 'rooms'] as const;

export function useRoomsQuery() {
  return useQuery({ queryKey: roomsKeys, queryFn: () => roomsApi.list() });
}

export function useCreateRoomMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Parameters<typeof roomsApi.create>[0]) => roomsApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: roomsKeys }),
  });
}

export function useUpdateRoomMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Parameters<typeof roomsApi.update>[1] }) =>
      roomsApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: roomsKeys }),
  });
}

export function useDeleteRoomMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => roomsApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: roomsKeys }),
  });
}
